import { Card } from "@volca/ui/components/ui/card";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

// Placeholder cards in the shape of the real ones, so the panel does not jump
// when the edits load.
export const ManualEditsSkeleton = () => (
  <Stack
    className="w-full"
    align="start"
    gap={2}
    role="status"
    aria-label="Loading manual edits"
  >
    <Skeleton className="mb-1 h-5 w-32" />
    {[0, 1, 2].map((index) => (
      <Card key={index} className="w-full gap-0 p-4">
        <Stack className="w-full" gap={2} align="stretch">
          <Stack
            className="w-full"
            align="start"
            gap={4}
            direction="row"
            justify="between"
          >
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-5 w-20 rounded-lg" />
          </Stack>
          <Skeleton className="h-5 w-28" />
          <Skeleton className="h-3 w-40" />
        </Stack>
      </Card>
    ))}
  </Stack>
);

export const ManualEditsEmptyState = () => (
  <Empty className={emptyStateVariants({ layout: "inline" })}>
    <EmptyHeader>
      <EmptyDescription>
        Nothing edited yet. Change a cell or add a row in the workbook and it
        shows up here, then applies again the next time payroll runs.
      </EmptyDescription>
    </EmptyHeader>
  </Empty>
);
